const state = {
    sessions:[],
    current: 0
}

// getters
const getters = {
    getTrainingDays: state => state.sessions.length,
    getTrainingIntervel: state => {
        const currentDate = new Date
        const date = `${ currentDate.getFullYear() }-${ currentDate.getMonth() > 8 ? currentDate.getMonth() + 1 : '0' + (currentDate.getMonth() + 1) }-${ currentDate.getDate() > 9 ? currentDate.getDate() : '0' + currentDate.getDate() }`
        if (state.sessions.length > 0 && state.sessions[state.sessions.length - 1].date === date) {
            return (state.sessions.length - 1) % 4
        } else {
            return state.sessions.length % 4
        }
    },
    getTrainingHours: state => {
        const ms = state.sessions.reduce((sum, item) => {
            sum += item.ms
            return sum
        }, 0)
        const mod = ms % 3600000
        const hours = (ms - mod) / 3600000
        const minutes = (mod - mod % 60000) / 60000
        return `${ hours }:${ minutes > 9 ? minutes : '0' + minutes }`
    },
    getTrainingRecord: state => {
        const ms = state.sessions.reduce((max, item) => Math.max(max, item.ms), 0)
        const mod = ms % 3600000
        const hours = (ms - mod) / 3600000
        const minutes = (mod - mod % 60000) / 60000
        return `${ hours }:${ minutes > 9 ? minutes : '0' + minutes }`
    },
    getTrainingAverage: state => {
        const ms = state.sessions.length > 0 ? state.sessions.reduce((sum, item) => {
            sum += item.ms
            return sum
        }, 0) / state.sessions.length : 0
        const mod = ms % 3600000
        const hours = (ms - mod) / 3600000
        const minutes = (mod - mod % 60000) / 60000
        return `${ hours }:${ minutes > 9 ? minutes : '0' + minutes }`
    },
    getTrainingState: state => {
        return {
            current: state.current
        }
    }
}

// actions
const actions = { }

// mutations
const mutations = {
    updateTraining (state, { date, ms }) {
        if (date instanceof Date && typeof ms === 'number' && ms > 0) {
            const currentDate = `${ date.getFullYear() }-${ date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1) }-${ date.getDate() > 9 ? date.getDate() : '0' + date.getDate() }`
            const key = state.sessions.length - 1
            if (state.sessions.length > 0 && state.sessions[state.sessions.length - 1].date === currentDate) {
                state.sessions[state.sessions.length - 1].ms += ms
            } else {
                state.sessions.push({
                    date: currentDate,
                    ms
                })
            }
        }
    },
    setWorkoutNumber (state, current) {
        if (typeof current === 'number' && current >= 0) {
            state.current = current
        }
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/fitnes/modules/history.js